import { handleError } from '@/utils/exception_handler';

import api from './api';

export default {

  // Uses CREATE mutations on USER MEMBERSHIPS
  inviteUser: (context, requestParams) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'inviteUser';

    commit(`${mutationPrefix}Pending`);

    return api.inviteUser(requestParams)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CUSTOM mutations on USER MEMBERSHIPS
  validateInvitationToken: (context, requestParams) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'validateInvitationToken';

    commit(`${mutationPrefix}Pending`);

    return api.validateInvitationToken(requestParams)
      .then((response) => {
        dispatch('insert', { data: response.entity });

        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses CUSTOM mutations on USER MEMBERSHIPS
  acceptInvitation: (context, data) => {
    const { commit } = context;
    const mutationPrefix = 'acceptInvitation';

    commit(`${mutationPrefix}Pending`);

    return api.acceptInvitation(data)
      .then((response) => {
        commit(`${mutationPrefix}Success`);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`))
      .catch(handleError(context, `${mutationPrefix}Error`));
  },

  // Uses UPDATE mutations on USER MEMBERSHIPS
  updateRole: (context, { id, data }) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'updateRole';

    commit(`${mutationPrefix}Pending`, id);

    return api.updateRole(id, data)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses UPDATE mutations on USER MEMBERSHIPS
  resendInvitation: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'resendInvitation';

    commit(`${mutationPrefix}Pending`, id);

    return api.resendInvitation(id)
      .then((response) => {
        dispatch('update', response.entity);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`), { id })
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  // Uses DELETE mutations on USER MEMBERSHIPS
  removeUserMembership: (context, id) => {
    const { commit, dispatch } = context;
    const mutationPrefix = 'removeUserMembership';

    commit(`${mutationPrefix}Pending`, id);

    return api.removeUserMembership(id)
      .then((response) => {
        dispatch('delete', id);

        commit(`${mutationPrefix}Success`, id);

        return { status: true, data: response };
      }, handleError(context, `${mutationPrefix}Error`, { id }))
      .catch(handleError(context, `${mutationPrefix}Error`, { id }));
  },

  setContext: ({ commit }, payload = null) => {
    commit('setContext', payload);
  },

  openFormModal: ({ commit }, payload = null) => {
    commit('openFormModal', payload);
  },

  closeFormModal: ({ commit }) => {
    commit('closeFormModal');
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/userMembership/actions.js